/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'
import { BulletList } from 'react-content-loader'
import moment from 'jalali-moment'

import Leaflet from 'leaflet'

import Menu from '../../components/Menu'

import { useNavigate } from 'react-router-dom'

import foodIcon from '../../assets/svg/orderIcon.svg'
import { get, put } from '../../services/http'
import { ToRial } from '../../services/toRial'

import { notify } from '../../components/Toast'
import { ToastContainer } from 'react-toastify'

import { MapContainer, TileLayer, Marker } from 'react-leaflet'

import seeIcon from '../../assets/svg/see.svg'
import iconUrl from '../../assets/svg/Location.svg'
import doingIcon from '../../assets/svg/orderDoing.png'
import readyIcon from '../../assets/svg/orderReady.svg'
import deliveryIcon from '../../assets/svg/Deliver.svg'
import caceledIcon from '../../assets/svg/Canceled.svg'

import dingSound from '../../assets/Audio/ding-sound-effect_2.mp3'

export const newicon = new Leaflet.Icon({
  iconUrl,
  iconAnchor: [5, 55],
  popupAnchor: [10, -44],
  iconSize: [45, 55]
})

export default function index() {
  document.title = 'سفارش‌ها'

  // eslint-disable-next-line react-hooks/exhaustive-deps
  let audio = new Audio(dingSound)

  const navigate = useNavigate()

  const [ordersNew, setOrdersNew] = useState()
  const [ordersDoing, setOrdersDoing] = useState()
  const [ordersReady, serOrdersReady] = useState()
  const [order, setOrder] = useState([])
  const [orderBasket, setOrderBasket] = useState([])
  const [orderUser, setOrderUser] = useState([])
  const [orderWay, setOrderWay] = useState([])

  const [modal, setModal] = useState(false)
  const [blurModal, setBlurModal] = useState(false)
  const [modalStatus, setModalStatus] = useState(false)
  const [cover, setCover] = useState(false)
  const [orderId, setOrderId] = useState('')

  const [soundAllow, setSoundAllow] = useState(false)
  const [clickOrderDoing, setClickOrderDoing] = useState(false)
  const [clickOrderReady, setClickOrderReady] = useState(false)
  const [clickOrderDone, setClickOrderDone] = useState(false)
  const [clickOrderCancel, setClickOrderCancel] = useState(false)
  const [mapDetails, setMapDetails] = useState([37.27579, 49.937])

  const token = localStorage.getItem('token')

  const navigateHandler = () => {
    navigate('/orders/select')
  }

  useEffect(() => {
    const timeout = setTimeout(() => {
      get(`/api/admin/order/paid?token=${token}`)
        .then(response => {
          setOrdersNew(response.data.data.filter(item => item.orderStatus === 'new'))
          // eslint-disable-next-line array-callback-return
          if(response.data.data.map(item => {
            if (item.orderStatus === 'new') {
              if (soundAllow) {
                audio.play()
              }
            }
          }))
          setOrdersDoing(response.data.data.filter(item => item.orderStatus === 'doing'))
          serOrdersReady(response.data.data.filter(item => item.orderStatus === 'ready'))
        })
        .catch(error => {
          window.location.reload()
        })
    }, 10000);

    return () => {
      clearTimeout(timeout);
    }
  }, [ordersNew, ordersDoing, soundAllow, audio, token])

  const seeOrderHandler = (e) => {
    if(e.target.id.length >= 1) {
      setCover(true)
      setModal(true)
      get(`/api/admin/order/${e.target.id}?token=${token}`)
        .then(response => {
          setOrder(response.data.data)
          setOrderBasket(response.data.data.basket)
          setOrderUser(response.data.data.user[0])
          setOrderWay(response.data.data.orderWay)
        })
        .catch(error => {
          notify('error', 'دریافت اطلاعات با خطا مواجه شد')
        })
    }
  }

  const changeStatusHandler = (e) => {
    if(e.target.id.length >= 1) {
      setOrderId(e.target.id)
      setCover(true)
      setModalStatus(true)
      setBlurModal(true)
      get(`/api/admin/order/${e.target.id}?token=${token}`)
        .then(response => {
          setBlurModal(false)
          setOrder(response.data.data)
          setOrderUser(response.data.data.user[0])
          setOrderWay(response.data.data.orderWay)
          setMapDetails(response.data.data.orderWay.orderDetail.selectedPosition)
        })
        .catch(error => {
          notify('error', 'دریافت اطلاعات با خطا مواجه شد')
        })
    }
  }

  const statusOrderHandler = (data) => {
    put(`/api/admin/order/changeStatus/${orderId}?token=${token}`, { orderStatus : data.type, phoneNumber: data.phoneNumber, orderNumber: data.orderNumber, id: data.id })
      .then(response => {
        if (response.data.success) {
          setCover(false)
          setModalStatus(false)
          setModal(false)
          notify('success', 'وضعیت سفارش مورد نظر تغییر کرد')
          setClickOrderDoing(false)
          setClickOrderReady(false)
          setClickOrderDone(false)
          setClickOrderCancel(false)
        }
      })
  }

  return (
    <main id='panel'>
      <ToastContainer rtl />
      <div className="cover" style={{ display: cover? '': 'none' }}>
      </div>
      <div className='orderModal' style={{ display: modal ? '' : 'none' }}>
        <div className="titleOrdalModal">
          سفارشات
        </div>
        <div className='row'>
          <span>وضعیت : <span className={order.orderStatus === 'new' ? 'emerColor' : 'dangerColor'}>{order.orderStatus === 'new' ? 'سفارش جدید' : 'سفارش در حال انجام' }</span></span>
          <span>زمان ثبت : {moment(order.updatedAt).locale('fa').format('YYYY/MM/DD HH:mm')}</span>
        </div>
        <div className='row'>
          <span>سفارش دهنده : {orderUser.name}</span>
          <span>با کد تخفیف : {order.discount}</span>
          <span>مبلغ پرداخت شده : <span className='success'>{ToRial(String(order.total))}</span> تومان</span>
        </div>
        <div className='row'>
          <span>شماره موبایل : {orderUser.phoneNumber}</span>
        </div>
        <hr />
        {orderBasket ? orderBasket.map(item => (
          <>
            <div key={item._id} className='rowBasket'>
              <span>نام غذا یا نوشیدنی : <span className='success'>{item.name}</span></span>
              <span>تعداد : <span className='success'>{item.count}</span></span>
            </div>
            <div className='rowBasket'>
              <span>قیمت واحد : {ToRial(String(item.price))} تومان</span>
            </div>
            <div className='rowBasket'>
              <span>قیمت کل : {ToRial(String(item.allPrice))} تومان</span>
            </div>
          </>
        )) : ''}
        <hr />
        <div className='row'>
          <span>جمع سبد خرید : {ToRial(String(order.productsTotal))} تومان</span>
        </div>
        <div className='row'>
          <span>آدرس : {orderWay.type === 'peyk' ? orderWay.orderDetail.addressSelect + ' - پلاک : ' + orderWay.orderDetail.plak + ' - طبقه : ' + orderWay.orderDetail.floor : orderWay.orderDetail}</span>
          <span></span>
        </div>
        <div className="buttons">
          <button onClick={() => navigate(`/order/${order._id}`)}>جرئیات بیشتر</button>
          <button onClick={e => {
            setCover(false)
            setModal(false)
          }}>مشاهده شد</button>
        </div>
      </div>
      <div className='orderModal' style={{ display: modalStatus ? '': 'none' , filter: blurModal ? 'blur(10px)' : 'blur(0px)' }}>
        <div className="titleOrdalModal">
          سفارشات
        </div>
        <div className='row'>
          <span>وضعیت : <span className={order.orderStatus === 'new' ? 'emerColor' : 'dangerColor'}>{order.orderStatus === 'new' ? 'سفارش جدید' : 'سفارش در حال انجام' }</span></span>
          <span>زمان ثبت : {moment(order.updatedAt).locale('fa').format('YYYY/MM/DD HH:mm')}</span>
        </div>
        <div className='row'>
          <span>سفارش دهنده : {orderUser.name}</span>
          <span>با کد تخفیف : {order.discount}</span>
          <span>مبلغ پرداخت شده : <span className='success'>{ToRial(String(order.total))}</span> تومان</span>
        </div>
        <div className='row'>
          <span>شماره موبایل : {orderUser.phoneNumber}</span>
        </div>
        <hr />
        <div className='row'>
          <span className='statusButton' onClick={(e) => {
              statusOrderHandler({ type: 'doing', phoneNumber: orderUser.phoneNumber, orderNumber: order.orderNumber })
              setClickOrderDoing(true)
            }}>
            {clickOrderDoing ? (
              <>
                <div className="text">
                  <div className="title dangerColor">
                    سفارش در حال انجام
                  </div>
                  <div className="subTitle">
                    لطفاً صبر کنید ...
                  </div>
                </div>
                <div className="pic">
                  <img src={doingIcon} alt="doingIcon" />
                </div>
              </>
            ) : (
              <>
                <div className="text">
                  <div className="title dangerColor">
                    سفارش در حال انجام
                  </div>
                  <div className="subTitle">
                    سفارش مشاهده شده و جهت تهیه به آشپزخانه سپرده شده
                  </div>
                </div>
                <div className="pic">
                  <img src={doingIcon} alt="doingIcon" />
                </div>
              </>
            )}
          </span>
          <span className='statusButton' onClick={() => {
              statusOrderHandler({ type: 'ready', phoneNumber: orderUser.phoneNumber, orderNumber: order.orderNumber, id: order._id })
              setClickOrderReady(true)
            }}>
            {clickOrderReady ? (
              <>
                <div className="text">
                  <div className="title success">
                    سفارشات آماده تحویل
                  </div>
                  <div className="subTitle">
                    لطفاً صبر کنید ...
                  </div>
                </div>
                <div className="pic">
                  <img src={readyIcon} alt="readyIcon" />
                </div>
              </>
            ) : (
              <>
                <div className="text">
                  <div className="title success">
                    سفارشات آماده تحویل
                  </div>
                  <div className="subTitle">
                    سفارش از آشپزخانه تحویل گرفته شده و آماده تحویل به مشتری
                  </div>
                </div>
                <div className="pic">
                  <img src={readyIcon} alt="readyIcon" />
                </div>
              </>
            )}
          </span>
        </div>
        <div className='row'>
          <span className='statusButton' onClick={() => {
              statusOrderHandler({ type: 'done', phoneNumber: orderUser.phoneNumber, orderNumber: order.orderNumber })
              setClickOrderDone(true)
            }}>
            {clickOrderDone ? (
              <>
                <div className="text">
                  <div className="title">
                    سفارش تحویل داده شد
                  </div>
                  <div className="subTitle">
                    لطفاً صبر کنید ...
                  </div>
                </div>
                <div className="pic">
                  <img src={deliveryIcon} alt="deliveryIcon" />
                </div>
              </>
            ) : (
              <>
                <div className="text">
                  <div className="title">
                    سفارش تحویل داده شد
                  </div>
                  <div className="subTitle">
                    سفارش به مشتری تحویل داده شده
                  </div>
                </div>
                <div className="pic">
                  <img src={deliveryIcon} alt="deliveryIcon" />
                </div>
              </>
            )}
          </span>
          <span className='statusButton' onClick={() => {
              statusOrderHandler({ type: 'cancel', phoneNumber: orderUser.phoneNumber, orderNumber: order.orderNumber })
              setClickOrderCancel(true)
            }}>
            {clickOrderCancel ? (
              <>
                <div className="text">
                  <div className="title" style={{ color: 'gray' }}>
                    سفارش کنسل شد
                  </div>
                  <div className="subTitle">
                    لطفاً صبر کنید ...
                  </div>
                </div>
                <div className="pic">
                  <img src={caceledIcon} alt="caceledIcon" />
                </div>
              </>
            ) : (
              <>
                <div className="text">
                  <div className="title" style={{ color: 'gray' }}>
                    سفارش کنسل شد
                  </div>
                  <div className="subTitle">
                    سفارش به دلایلی کنسل شده
                  </div>
                </div>
                <div className="pic">
                  <img src={caceledIcon} alt="caceledIcon" />
                </div>
              </>
            )}
          </span>
        </div>
        <hr />
        <div className='row'>
          <span>آدرس : {orderWay.type === 'peyk' ? orderWay.orderDetail.addressSelect + ' - پلاک : ' + orderWay.orderDetail.plak + ' - طبقه : ' + orderWay.orderDetail.floor : orderWay.orderDetail}</span>
          <span>زمان تحویل : {order.timeDeliver}</span>
        </div>
        <div className='row'>
          {orderWay.type === 'peyk' ? <MapContainer style={{ width: '800px', height: '300px' }} center={mapDetails.length > 0 ? [mapDetails[0], mapDetails[1]] : []} zoom={16} scrollWheelZoom={false}>
              <Marker icon={newicon} position={mapDetails ? [mapDetails[0], mapDetails[1]] : [37.27579, 49.937]} />
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
            </MapContainer> : ''}
        </div>
        <div className="buttons">
          <button onClick={() => navigate(`/order/${order._id}`)}>جرئیات بیشتر</button>
          <button onClick={e => {
            setCover(false)
            setModalStatus(false)
          }}>مشاهده شد</button>
        </div>
      </div>
      <Menu page={'order'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className="right">
              <div className='icon'>
                <img src={foodIcon} alt='resturantIcon' />
              </div>
              <div className='text'>
                سفارش‌‌ها
              </div>
            </div>

            <div className="left">
              <button style={soundAllow ? { backgroundColor: 'green', margin: '0 0.5em' } : { backgroundColor: 'gray', margin: '0 0.5em' }} onClick={() => setSoundAllow(!soundAllow)}>پخش زنگ هشدار</button>
              <button onClick={navigateHandler}>کلیه سفارشات</button>
            </div>
          </div>

          <div className="tablePart">
            <div className="title">
              <div className="right" style={{ color: '#FF7A00' }}>
                سفارشات جدید
              </div>
              <div className="left">
                {ordersNew ? ordersNew.length : ''}
              </div>
            </div>

            <table className='table'>
              <thead>
                <tr>
                  <th>شماره سفارش</th>
                  <th>سفارش دهنده</th>
                  <th>جمع</th>
                  <th>تاریخ خرید</th>
                  <th>وضعیت</th>
                  <th>عملیات</th>
                </tr>
              </thead>
              <tbody>
                {ordersNew ? ordersNew.map(item => (
                    <tr key={item._id}>
                      <td>{item.orderNumber}</td>
                      <td>{item.user[0].name}</td>
                      <td>{ToRial(String(item.total))} تومان</td>
                      <td>{moment(item.updatedAt).locale('fa').format('YYYY/MM/DD HH:mm')} </td>
                      <td style={{ color: '#FF7A00' }}>سفارشات جدید</td>
                      <td className='tdClass'>
                        <button className='seeIcon' onClick={seeOrderHandler}>
                          <img id={item._id} src={seeIcon} alt='seeIcon' />
                        </button>
                        <button id={item._id} onClick={changeStatusHandler}>تعیین وضعیت</button>
                      </td>
                    </tr>
                  )) : <tr><td colSpan="5"><BulletList rtl style={{ width: '30%', rowspan: '5' }}/></td></tr>}
              </tbody>
            </table>
          </div>

          <div className="tablePart">
            <div className="title">
              <div className="right" style={{ color: '#FD3A50' }}>
                سفارشات در حال انجام
              </div>
              <div className="left">
                {ordersDoing ? ordersDoing.length : ''}
              </div>
            </div>

            <table className='table'>
              <thead>
                <tr>
                  <th>شماره سفارش</th>
                  <th>سفارش دهنده</th>
                  <th>جمع</th>
                  <th>تاریخ خرید</th>
                  <th>وضعیت</th>
                  <th>عملیات</th>
                </tr>
              </thead>
              <tbody>
                {ordersDoing ? ordersDoing.map(item => (
                    <tr key={item._id}>
                      <td>{item.orderNumber}</td>
                      <td>{item.user[0].name}</td>
                      <td>{ToRial(String(item.total))} تومان</td>
                      <td>{moment(item.updatedAt).locale('fa').format('YYYY/MM/DD HH:mm')} </td>
                      <td style={{ color: '#FD3A50' }}>سفارشات در حال انجام</td>
                      <td className='tdClass'>
                        <button className='seeIcon' onClick={seeOrderHandler}>
                          <img id={item._id} src={seeIcon} alt='seeIcon' />
                        </button>
                        <button id={item._id} onClick={changeStatusHandler}>تعیین وضعیت</button>
                      </td>
                    </tr>
                  )) : <tr><td colSpan="5"><BulletList rtl style={{ width: '30%', rowspan: '5' }}/></td></tr>}
              </tbody>
            </table>
          </div>

          <div className="tablePart">
            <div className="title">
              <div className="right" style={{ color: '#198524' }}>
                سفارشات آماده تحویل
              </div>
              <div className="left">
                {ordersReady ? ordersReady.length : ''}
              </div>
            </div>

            <table className='table'>
              <thead>
                <tr>
                  <th>شماره سفارش</th>
                  <th>سفارش دهنده</th>
                  <th>جمع</th>
                  <th>تاریخ خرید</th>
                  <th>وضعیت</th>
                  <th>عملیات</th>
                </tr>
              </thead>
              <tbody>
                {ordersReady ? ordersReady.map(item => (
                    <tr key={item._id}>
                      <td>{item.orderNumber}</td>
                      <td>{item.user[0].name}</td>
                      <td>{ToRial(String(item.total))} تومان</td>
                      <td>{moment(item.updatedAt).locale('fa').format('YYYY/MM/DD HH:mm')} </td>
                      <td style={{ color: '#198524' }}>سفارشات آماده تحویل</td>
                      <td className='tdClass'>
                        <button className='seeIcon' onClick={seeOrderHandler}>
                          <img id={item._id} src={seeIcon} alt='seeIcon' />
                        </button>
                        <button id={item._id} onClick={changeStatusHandler}>تعیین وضعیت</button>
                      </td>
                    </tr>
                  )) : <tr><td colSpan="5"><BulletList rtl style={{ width: '30%', rowspan: '5' }}/></td></tr>}
              </tbody>
            </table>
          </div>

          <div className="copyright">
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
